/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getExperiments} from '../api'

 export const useQueryGetExperiments = createReactQueryHook('getExperiments', getExperiments)
